import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ClientCustomerListItemType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import TableHeadTdOrder from 'components/others/TableHeadTdOrder';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import { useCustomersList } from '../context/CustomersListProvider';
import CustomersListTableBody from './CustomersListTableBody';

interface CustomersListTableProps {
    rows: ClientCustomerListItemType[];
    onEdit: (row: ClientCustomerListItemType) => void;
    onDelete: (row: ClientCustomerListItemType) => void;
    onCreateSale: (sale: NewSaleType) => void;
    onCreateObject: (object: NewObjectType) => void;
}

const CustomersListTable = ({
    rows,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
}: CustomersListTableProps) => {
    const { t } = useTranslation(['Clients']);
    const {
        showSpinner,
        customersOrder,
        setCustomersOrder,
        customersDesc,
        setCustomersDesc,
        showVat,
        showPersonType,
    } = useCustomersList();
    const tableMinWidth = 500 + (showVat ? 90 : 0) + (showPersonType ? 130 : 0);

    const handleOrderClick = (value: string, desc: boolean) => {
        setCustomersOrder(value);
        setCustomersDesc(desc);
    };

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="CustomersListTable table-hover mb-0" style={{ minWidth: tableMinWidth }}>
                    <thead>
                        <tr className="bg-light">
                            <td className="head-subject-name">
                                <TableHeadTdOrder
                                    title={t('subjects.fields.fullName')}
                                    onClick={handleOrderClick}
                                    value={customersOrder}
                                    desc={customersDesc}
                                    fieldName="v_client_customers.full_name"
                                />
                            </td>
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('subjects.fields.client')}
                                    onClick={handleOrderClick}
                                    value={customersOrder}
                                    desc={customersDesc}
                                    fieldName="v_clients.client_name"
                                />
                            </td>
                            {showVat ? (
                                <td className="head-vat">
                                    <TableHeadTdOrder
                                        title={t('subjects.fields.vatEnabled')}
                                        onClick={handleOrderClick}
                                        value={customersOrder}
                                        desc={customersDesc}
                                        fieldName="v_client_customers.vat_enabled"
                                    />
                                </td>
                            ) : null}
                            {showPersonType ? <td className="head-status">{t('subjects.fields.personType')}</td> : null}
                            <td className="head-action">{t('subjects.fields.action')}</td>
                        </tr>
                    </thead>
                    <CustomersListTableBody
                        rows={rows}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onCreateSale={onCreateSale}
                        onCreateObject={onCreateObject}
                    />
                </Table>
            </div>
        </div>
    );
};

export default CustomersListTable;
